import Content from '../../content.js';
import EventEmitter from '../../../util/eventEmitter.js';

namespace('IO.Views.PaymentDevices', function (exports) {
  'use strict';

  var numberRegex = /^\d*$/,
    New = Content.extend({
      dom: {
        SELECT2_FIELD: '.select2select',
        PD_SELECT2_FIELD: '.pdt-select',
        VENDOR_SELECTOR: '#vendor-selector',
        NAME_SELECTOR: '#name-selector',
        MODEL_SELECTOR: '#model-selector',
        FIRMWARE: '#firmware',
        HARDWARE: '#hardware',
        P2PE_PAYMENT_APPLICATIONS: '#p2pe-payment-applications',
        P2PE_NON_PAYMENT_APPLICATIONS: '#p2pe-non-payment-applications',
        PDT_PST: '#pdt-pts',
        PDT_CERTIFICATION: '#pdt-certification',
        PDT_ENCRYPTION: '#pdt-encryption',
        PDT_PRODUCT: '#pdt-product',
        PDT_PORT: '#pdt-port',
        PAYMENT_DEVICE_TYPE_SELECT: '.payment-device-type-select',
        QUERY_PINPAD_BUTTON: '#query-pinpad-button',
        VISIBLE_FORM: 'form:visible',
        REGISTER_NUMBER_FIELD: '#payment_device_register_number',
        SERIAL_ID: '#payment_device_serial_id',
        IP_ADDRESS: '#payment_device_device_ip',
      },

      select2Options: {
        default: {},
      },

      subscriptionId: false,
      nameManuallyChanged: false,
      lastUpdateTimestamp: 0,

      events: function () {
        var events = {};

        events['click ' + this.dom.QUERY_PINPAD_BUTTON] = '_queryPinpad';
        events['change ' + this.dom.NAME_SELECTOR] = '_proxyNameChange';
        events['change ' + this.dom.VENDOR_SELECTOR] = '_populateModels';
        events['change ' + this.dom.MODEL_SELECTOR] = '_populateFirmwares';
        events['change ' + this.dom.FIRMWARE] = '_populateDeviceInfo';
        events['keyup ' + this.dom.REGISTER_NUMBER_FIELD] =
          '_warnRegisterNumber';
        return events;
      },

      _buildWebsocketChannel: function () {
        return (
          '/pinpad_retrieve_' + location.pathname.split('payment_devices/')[1]
        );
      },

      _listen: function (callback) {
        if (!this.subscriptionId) {
          this.subscriptionId = Messenger.on(
            this._buildWebsocketChannel(),
            callback,
          );
        }
      },

      onDestroy: function () {
        if (this.subscriptionId) {
          Messenger.off(this._buildWebsocketChannel(), this.subscriptionId);
        }
      },

      _warnRegisterNumber: function (e) {
        var element = $(e.target),
          submitButton = $('.io-form').find('.submit.io-form-action-save');

        if (!emEnabled) {
          return;
        }

        element.closest('td').find('small.error').remove();
        submitButton.attr('disabled', false);
        if (!e.target.value.match(numberRegex)) {
          submitButton.attr('disabled', true);
          element
            .closest('td')
            .append(
              '<small class="error">Invalid value, is not a number.</small>',
            );
        }
      },

      _nameProgramaticallyChanged: function () {
        var programaticallyChanged = this.nameSelector.attr(
          'programaticallyChanged',
        );

        return (
          typeof programaticallyChanged !== 'undefined' &&
          programaticallyChanged
        );
      },

      _notifyAboutUpdate: function (options) {
        $.ajax(options).fail(function (response) {
          try {
            msg = JSON.parse(response.responseText).error;
          } catch {
            msg = response.statusText;
          }
          alert(msg);
        });
      },

      _confirmSerialIDUpdate: function (data) {
        var warnModal,
          serialID =
            data.logs[data.logs.length - 1].received_data.pinpad_serial_number,
          deviceID = data.payment_device.id,
          code = data.c_code,
          queryURL = '/' + code + '/duplicated_serial_number',
          authorizeURL = '/' + code + '/authorize_update_serial_number',
          ajaxOptions;

        ajaxOptions = {
          type: 'POST',
          url: authorizeURL,
          data: {
            authenticity_token: $('meta[name=csrf-token]').attr('content'), // eslint-disable-line camelcase
            devices: JSON.stringify([
              { device_id: deviceID, serial_id: serialID },
            ]), // eslint-disable-line camelcase
            authorized: false,
          },
        };

        warnModal = new IO.Views.Components.ConfirmationDialog({
          url: queryURL,
          template: 'payment_devices/devices_same_serial_id',
          method: 'POST',
          width: 700,
        });

        warnModal.on(
          'modalEscaped',
          function () {
            this._notifyAboutUpdate(ajaxOptions);
            warnModal.destroy();
          }.bind(this),
        );
        warnModal.impact({
          serials: JSON.stringify([
            { device_id: deviceID, serial_id: serialID },
          ]),
          single_retrieval: true,
        }); // eslint-disable-line camelcase
        warnModal.answer(
          function (proceed) {
            if (proceed) {
              ajaxOptions.data.authorized = true;
            }

            this._notifyAboutUpdate(ajaxOptions);
            warnModal.destroy();
          }.bind(this),
        );
      },

      _queryPinpad: function (event) {
        var msg,
          $input,
          field = $('#payment_device_serial_id');

        event.preventDefault();
        if ($(event.target).attr('disabled') === 'disabled') {
          return;
        }
        $(event.target).attr('disabled', true);

        if (field.parents('td').find('.status').length > 0) {
          field
            .parents('td')
            .find('.status')
            .removeClass()
            .addClass('status')
            .text('Retrieving...');
        } else {
          field.parents('td').append('<div class="status">Retrieving...</div>');
        }

        this._listen(
          function (data) {
            var status = field.parents('td').find('.status'),
              url;

            if (data.error === true) {
              return this._confirmSerialIDUpdate(data);
            }

            $(event.target).attr('disabled', false);
            if (
              data.changes === undefined &&
              _.last(data.logs).status === 'success'
            ) {
              status.remove();
              return;
            }

            if (
              data.changes !== undefined &&
              Object.keys(data.changes).length > 0
            ) {
              $.each(data.changes, function (prop, value) {
                $input = $('input[name="payment_device[' + prop + ']"]');
                if ($input.val() === value[1]) {
                  return;
                }
                $input.parents('.control').addClass('color-green');
                $input.val(value[1]);
                if (value[0] !== null) {
                  $input.prop('title', 'Previously "' + value[0] + '"');
                }
              });
            } else {
              $('.control.color-green').removeClass('color-green');
            }

            if (_.last(data.logs).status === 'running') {
              return;
            }

            // Whenever a the variable gets updated this change needs to be updated on UI
            // if for some reason the timestamp is not present, it does nothing
            this._updateStatusTimestamp(data.payment_device.status_last_update);

            if (
              typeof data.payment_device.serial_id === 'undefined' &&
              data.changes.pinpad_job_status
            ) {
              status.text(data.changes.pinpad_job_status);
            } else if (_.last(data.logs).status === 'failure') {
              url = field.parents('td').find('.show-disabled a').attr('href');
              field
                .parent()
                .parent()
                .find('a')
                .text(data.payment_device.serial_id);
              status
                .addClass('failure')
                .html(
                  'An error occurred. <a href="' +
                    url +
                    '">Click here</a> for details.',
                );
            } else {
              field.val(data.payment_device.serial_id);
              field
                .parent()
                .parent()
                .find('a')
                .text(data.payment_device.serial_id);
              status.remove();
            }
          }.bind(this),
        );

        $.ajax({
          type: 'POST',
          url:
            location.pathname.split('/payment_devices')[0] +
            '/payment_devices/retrieve_pinpad_data',
          data: {
            authenticity_token: $('meta[name=csrf-token]').attr('content'), // eslint-disable-line camelcase
            payment_device_ids: location.pathname.split('payment_devices/')[1], // eslint-disable-line camelcase
          },
        }).fail(function (response) {
          try {
            msg = JSON.parse(response.responseText).error;
          } catch {
            msg = response.statusText;
          }
          alert(msg);
        });
      },

      _updateStatusTimestamp: function (timestamp) {
        if (typeof timestamp === 'undefined') {
          return;
        }

        EventEmitter.emit(
          '/timezone_status_last_update_date_update',
          timestamp,
        );
      },

      _proxyNameChange: function () {
        if (
          !this._nameProgramaticallyChanged() ||
          this._nameProgramaticallyChanged() === 'false'
        ) {
          this.nameChanged = true;
          this._populateVendor();
        }
        this.nameSelector.attr('programaticallyChanged', false);
      },

      _setName: function (val) {
        this.nameChanged = false;
        this.nameSelector.attr('programaticallyChanged', true);
        this._setSelectValue(this.nameSelector, val);
      },

      render: function () {
        var $select = this.$(this.dom.SELECT2_FIELD);

        PropertyTypeMask.applyMasks.call(this);

        this.nameSelector = this.$(this.dom.NAME_SELECTOR);
        this.vendorSelector = this.$(this.dom.VENDOR_SELECTOR);
        this.modelSelector = this.$(this.dom.MODEL_SELECTOR);
        this.firmwareSelector = this.$(this.dom.FIRMWARE);

        if (!$select.closest('.hide').length) {
          this.vendorSelect2 = $select.select2();
        }

        $(this.dom.PD_SELECT2_FIELD).each(function (i, item) {
          $(item).select2({
            placeholder: $(item).attr('placeholder'),
          });
        });

        this.trigger('change', this.dom.VENDOR_SELECTOR);
      },

      _filterPaymentDeviceType: function (data, callback) {
        $.ajax({
          url: '/' + currentCustomer + '/payment_device_types/filter',
          method: 'GET',
          data: {
            device_type: data, // eslint-disable-line camelcase
          },
        }).done(callback);
      },

      _rebuildSelect: function (el, data, key, selectFirst) {
        var modelOptions = [],
          modelHTMLOptions = [],
          opts = this._getOpts(el),
          placeholder = el.find('option:eq(0)').text(),
          counter = 0;

        if (data.length === 0) {
          el.attr('disabled', 'disabled');
          return;
        }

        if (
          !Object.prototype.hasOwnProperty.call(
            this._getOpts(el),
            'placeholder',
          )
        ) {
          modelHTMLOptions.push('<option val="">' + placeholder + '</option>');
        }

        el.prop('disabled', false);

        for (counter; counter < data.length; counter++) {
          if (modelOptions.indexOf(data[counter][key]) === -1) {
            modelOptions.push(data[counter][key]);
            if (data[counter][key] !== null) {
              modelHTMLOptions.push(
                '<option value="' +
                  data[counter][key] +
                  '">' +
                  data[counter][key] +
                  '</option>',
              );
            }
          }
        }

        modelHTMLOptions.join('\n');

        el.html(modelHTMLOptions).select2(opts);

        if (selectFirst) {
          this._setSelectValue(el, data[0][key]);
        }
      },

      _getOpts: function (el) {
        var opts = this.select2Options.default;

        if (
          Object.prototype.hasOwnProperty.call(
            this.select2Options,
            el.attr('id'),
          )
        ) {
          opts = this.select2Options[el.attr('id')];
        }
        return opts;
      },

      _resetSelect: function (el) {
        var opts = this._getOpts(el),
          placeholder = el.find('option:eq(0)').text();

        el.html('<option val="">' + placeholder + '</option>')
          .attr('disabled', 'disabled')
          .select2(opts);
      },

      _setSelectValue: function (el, value) {
        el.val(value).trigger('change');
      },

      _populateVendor: function () {
        var self = this;

        this._filterPaymentDeviceType(
          { name: this.nameSelector.val() },
          function (data) {
            self._setSelectValue(self.vendorSelector, data[0].vendor);
          },
        );
      },

      _populateModels: function () {
        var self = this,
          options = {
            vendor: this.vendorSelector.val(),
          };

        if (this.nameChanged) {
          options.name = this.nameSelector.val();
        }

        this._filterPaymentDeviceType(options, function (data) {
          self.nameManuallyChanged = false;

          if (data.length > 0) {
            self._rebuildSelect(self.modelSelector, data, 'model_number', true);
            self._setName(data[0].name);
            self.$(self.dom.FIRMWARE).val('');
          } else {
            self.modelSelector
              .attr('disabled', 'disabled')
              .val('')
              .trigger('change');
            self.$(self.dom.FIRMWARE).val('');
            self._setName('');
          }

          self._resetPaymentDeviceInfo();
        });
      },

      _populateFirmwares: function () {
        var self = this;

        this._filterPaymentDeviceType(
          {
            name: this.nameSelector.val(),
            vendor: this.vendorSelector.val(),
            model_number: this.modelSelector.val(), // eslint-disable-line camelcase
          },
          function (data) {
            if (data.length > 0) {
              self
                .$(self.dom.FIRMWARE)
                .val(data[0].firmware_version)
                .trigger('change');
            } else {
              self.$(self.dom.FIRMWARE).val('').trigger('change');
            }

            self._resetPaymentDeviceInfo();
          },
        );
      },

      _populateDeviceInfo: function () {
        var self = this;

        this._filterPaymentDeviceType(
          {
            vendor: this.vendorSelector.val(),
            model_number: this.modelSelector.val(), // eslint-disable-line camelcase
            firmware_version: this.firmwareSelector.val(), // eslint-disable-line camelcase
          },
          function (data) {
            if (data.length === 0) {
              return;
            }

            self.$(self.dom.HARDWARE).val(data[0].hardware_version);
            self
              .$(self.dom.P2PE_PAYMENT_APPLICATIONS)
              .val(data[0].p2pe_payment_applications);
            self
              .$(self.dom.P2PE_NON_PAYMENT_APPLICATIONS)
              .val(data[0].p2pe_non_payment_applications);

            self.$(self.dom.PDT_PST).val(data[0].pts_certification_id);
            self
              .$(self.dom.PDT_CERTIFICATION)
              .val(data[0].certification_expiration);
            self.$(self.dom.PDT_ENCRYPTION).val(data[0].encryption_type);
            self.$(self.dom.PDT_PRODUCT).val(data[0].product_type);
            self.$(self.dom.PDT_PORT).val(data[0].port);
          },
        );
      },

      _resetPaymentDeviceInfo: function () {
        this.$(this.dom.PDT_PST).val('');
        this.$(this.dom.PDT_CERTIFICATION).val('');
        this.$(this.dom.PDT_ENCRYPTION).val('');
        this.$(this.dom.PDT_PRODUCT).val('');
        this.$(this.dom.PDT_PORT).val('');
        this.$(this.dom.HARDWARE).val('');
        this.$(this.dom.P2PE_PAYMENT_APPLICATIONS).val('');
        this.$(this.dom.P2PE_NON_PAYMENT_APPLICATIONS).val('');
      },
    });

  exports.New = New;
});
